export default "__VITE_ASSET__f752b0e1__"